/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindListingsAv8Request } from './FindListingsAv8Request';
import {
    FindListingsAv8RequestFromJSON,
    FindListingsAv8RequestFromJSONTyped,
    FindListingsAv8RequestToJSON,
    FindListingsAv8RequestToJSONTyped,
} from './FindListingsAv8Request';

/**
 * 
 * @export
 * @interface ArtifactWidgetListingsSearchContent
 */
export interface ArtifactWidgetListingsSearchContent {
    /**
     * Originating artifact's id.
     * @type {string}
     * @memberof ArtifactWidgetListingsSearchContent
     */
    artifactId?: string;
    /**
     * 
     * @type {FindListingsAv8Request}
     * @memberof ArtifactWidgetListingsSearchContent
     */
    arguments: FindListingsAv8Request;
}

/**
 * Check if a given object implements the ArtifactWidgetListingsSearchContent interface.
 */
export function instanceOfArtifactWidgetListingsSearchContent(value: object): value is ArtifactWidgetListingsSearchContent {
    if (!('arguments' in value) || value['arguments'] === undefined) return false;
    return true;
}

export function ArtifactWidgetListingsSearchContentFromJSON(json: any): ArtifactWidgetListingsSearchContent {
    return ArtifactWidgetListingsSearchContentFromJSONTyped(json, false);
}

export function ArtifactWidgetListingsSearchContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactWidgetListingsSearchContent {
    if (json == null) {
        return json;
    }
    return {
        
        'artifactId': json['artifactId'] == null ? undefined : json['artifactId'],
        'arguments': FindListingsAv8RequestFromJSON(json['arguments']),
    };
}

export function ArtifactWidgetListingsSearchContentToJSON(json: any): ArtifactWidgetListingsSearchContent {
    return ArtifactWidgetListingsSearchContentToJSONTyped(json, false);
}

export function ArtifactWidgetListingsSearchContentToJSONTyped(value?: ArtifactWidgetListingsSearchContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'artifactId': value['artifactId'],
        'arguments': FindListingsAv8RequestToJSON(value['arguments']),
    };
}

